import React, { useState, ReactNode } from "react";
import styled from "styled-components";
import { DropdownIconDown, DropdownIconUp } from "../Icons/DropdownIcon";

interface AccordionProps {
  title: string;
  logo: string | React.ComponentType;
  tokenAmount: number | string;
  children?: ReactNode;
  expandable?: boolean;
  endIcon?: string;
  ineligible?: boolean;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  logo,
  tokenAmount,
  children,
  expandable = true,
  endIcon,
  ineligible = false
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleHeaderClick = () => {
    if (expandable) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <AccordionWrapper>
      <AccordionHeader
        onClick={handleHeaderClick}
        isOpen={isOpen}
        className={isOpen ? "expanded" : "hoverable"}
        ineligible={ineligible || tokenAmount == '0'}
      >
        <LogoAndWrapper>
          <LogoWrapper>
            {typeof logo === "string" ? (
              <img src={logo} alt={title} />
            ) : (
              <SvgWrapper>{React.createElement(logo)}</SvgWrapper>
            )}
          </LogoWrapper>
          <Title>{title}</Title>
        </LogoAndWrapper>
        <TokenAmountWrapper>
          <TokenAmount>{tokenAmount}</TokenAmount>
          {expandable && (
            <DropDownIconsWrapper>
              {isOpen ? <DropdownIconUp /> : <DropdownIconDown />}
            </DropDownIconsWrapper>
          )}
          {endIcon &&
            <div style={{width: '24px', marginLeft: '8px'}}>
                <img style={{width: '24px'}} src={endIcon}/>
            </div>
          }
        </TokenAmountWrapper>
      </AccordionHeader>
      {isOpen && expandable && (
        <AccordionContent isOpen={isOpen}>{children}</AccordionContent>
      )}
    </AccordionWrapper>
  );
};

const LogoAndWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.span`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TokenAmountWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 80px;
  justify-content: flex-end;
  margin-left: 20px;
`;

const TokenAmount = styled.span`
  white-space: nowrap;
`;

const DropDownIconsWrapper = styled.div`
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;

const AccordionWrapper = styled.div`
  width: 100%;
  border-radius: 20px;
  background-color: #151530;
  margin-bottom: 15px;
`;

const AccordionHeader = styled.div<{ isOpen: boolean, ineligible: boolean }>`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 18px 24px;
  color: #ffffff;
  // background-color: #0a0e27;
  background-color: rgb(21, 21, 48);
  border-radius: 20px;
//   border: 1px solid #07c0fb;
  // border: 1px solid #1e2239;
  box-sizing: border-box;

  ${(props) =>
    props.isOpen &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: none;
  `}

  ${(props) =>
    props.ineligible &&
    `
    opacity: 0.3;
  `}
`;

const AccordionContent = styled.div<{ isOpen: boolean }>`
  //background-color: #0a0e27;
  background-color: rgb(16, 16, 42);
  padding: 20px;
  color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-sizing: border-box;
  border: 1px solid #07c0fb;
  // border: 1px solid #1e2239;
  border-top: ${(props) => (props.isOpen ? "1px solid #07c0fb" : "none")};
`;

const LogoWrapper = styled.div`
  height: 30px;
  width: 30px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > img,
  & > svg {
    height: 100%;
    width: 100%;
  }
`;

const SvgWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    height: 100%;
    width: 100%;
  }
`;

export default Accordion;
